import React from 'react';
import {
  Player,
  EmptyPlayer,
  EmptyPlayerSlot,
  PlayersCount,
  PlayersCountNoNum,
  PlayersInner,
  PlayersList,
  PlayersPairs,
  NoPlayersMessage,
  ActionButton,
  LoginButton,
  NoActionButton,
  GamePlayers,
  KingOfTheHillPlayers,
  KingOfTheHillResults,
  KingOfTheHillPrePlayers,
  MorningOpenPlayers,
  MorningOpenPrePlayers,
  RandomRelationsPlayers,
  RandomRelationsResults,
  RandomRelationsPrePlayers,
  RandomRelationsMiniPlayers,
  TrainingQueue,
  GameDetailsInnerSummary,
  AlertInfo,
  AlertDanger,
  AlertPrepayment,
  AlertAfterReg,
  AlertTraining
} from './final.js';

class PlayerPair extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const { player, inPairGroup } = this.props;
    const RowTag = inPairGroup ? 'div' : 'li';

    return(
        <RowTag className="game__list-user">
            <div className="game__list-user-photo">
                {player._rating_level > 0 && (
                    <div className={`player-avatar-ring level-${player._rating_level}`}></div>
                )}
                <img className="img-responsive game__list-pair-photo"
                     src={player._photo}
                     alt={player._first_name + ' ' + player._last_name}
                />
            </div>
            <div className="game__list-user-name">
                <a href={'/profile/'+ player._id + '/'}>
                    {player._first_name + ' ' + player._last_name}
                </a>
            </div>
        </RowTag>
    );
  }
}
export default PlayerPair;
